import { useAuth } from '../context/AuthContext';
import { useCallback } from 'react';

/**
 * Hook to handle API errors including auth failures
 * Usage: 
 *   const handleApiError = useApiErrorHandler();
 *   try {
 *     const res = await apiCall();
 *   } catch (err) {
 *     handleApiError(err);
 *   }
 */
export const useApiErrorHandler = () => {
  const { handleAuthFailure } = useAuth();

  return useCallback((error) => {
    const status = error?.response?.status;
    const errorData = error?.response?.data;

    if (status === 401 || status === 403) {
      // Auth failure - trigger logout and redirect
      const message = errorData?.detail || 
                     errorData?.error || 
                     'Session expired. Please sign in again.';
      handleAuthFailure(message);
      return true; // Indicate it was an auth error
    }

    return false; // Not an auth error
  }, [handleAuthFailure]);
};
